<template>
<div v-show="visible" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header" class="text-center">
                <i class="fas fa-info-circle"></i>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body" class="text-center">
              {{ errorMessage }}
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-large btn-default center-block" v-on:click="close">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'Modal',

    props: { visible: {type: Boolean, default: false} , errorMessage: {type: String, default: "error"} },

    methods: {
        close() {
            this.$emit('closeDialog');
        }
    }
  }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}

.modal-container .btn {
  margin: 0 auto;
}

.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}

.modal-body {
  margin: 20px 0;
  white-space: pre-line 
}

.modal-default-button {
  margin: 0 auto;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>